import { render, staticRenderFns } from "./mention_tag.vue?vue&type=template&id=779490de"
import script from "./mention_tag.vue?vue&type=script&lang=js"
export * from "./mention_tag.vue?vue&type=script&lang=js"
import style0 from "./mention_tag.vue?vue&type=style&index=0&id=779490de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports